import { useEffect, useMemo, useRef, useState } from 'react';
import { fetchSiteSummaries, type SiteSummary } from '../lib/remote';
import type { Site } from '../lib/types';

export function useSiteSummaries(token: string | undefined, sites: Site[]) {
  const [summaries, setSummaries] = useState<SiteSummary[]>([]);
  const sitesRef = useRef(sites);
  sitesRef.current = sites;
  const siteKey = useMemo(
    () => sites.map((s) => `${s.id}:${s.trackingCode}`).join('|'),
    [sites]
  );

  useEffect(() => {
    if (!token || !siteKey) {
      setSummaries([]);
      return;
    }
    let cancelled = false;
    const load = async () => {
      const items = await fetchSiteSummaries(token, sitesRef.current);
      if (!cancelled) setSummaries(items);
    };
    load();
    const timer = window.setInterval(load, 15000);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, [token, siteKey]);

  return summaries;
}
